export const lazyLoadingTestId = 'lazyLoading';
